/* ============================================================
   360 ENVY — THEME JS
   ============================================================ */
(function () {
  'use strict';

  /* ---- Helpers ---- */
  function $(id) { return document.getElementById(id); }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function lockScroll()   { document.body.classList.add('scroll-lock'); }
  function unlockScroll() {
    /* Only unlock if nothing else has the scroll locked */
    var cdOpen  = cdDrawer  && cdDrawer.classList.contains('open');
    var navOpen = mobileNav && mobileNav.classList.contains('open');
    if (!cdOpen && !navOpen) {
      document.body.classList.remove('scroll-lock');
    }
  }

  /* ---- Page Loader ---- */
  window.addEventListener('load', function () {
    setTimeout(function () {
      var el = $('page-loader');
      if (el) el.classList.add('hidden');
    }, 1500);
  });

  /* ---- Sticky Header ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ---- Mobile Nav ---- */
  var navToggle  = document.querySelector('.nav-toggle');
  var mobileNav  = $('mobile-nav');
  var navOverlay = $('mobile-nav-overlay');
  var navClose   = document.querySelector('.mobile-nav-close');

  function openNav() {
    if (mobileNav)  mobileNav.classList.add('open');
    if (navOverlay) navOverlay.classList.add('open');
    lockScroll();
  }
  function closeNav() {
    if (mobileNav)  mobileNav.classList.remove('open');
    if (navOverlay) navOverlay.classList.remove('open');
    unlockScroll();
  }

  if (navToggle)  navToggle.addEventListener('click', openNav);
  if (navClose)   navClose.addEventListener('click', closeNav);
  if (navOverlay) navOverlay.addEventListener('click', closeNav);

  /* ---- Scroll Fade-In ---- */
  var fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    fadeEls.forEach(function (el) { io.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ---- Product Gallery Thumbnails ---- */
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product-gallery__main img');
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });

  /* ---- Product Tabs ---- */
  document.querySelectorAll('.tab-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.tab;
      document.querySelectorAll('.tab-trigger').forEach(function (t) { t.classList.remove('active'); });
      document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById(id);
      if (panel) panel.classList.add('active');
    });
  });

  /* ---- Quantity Buttons (product page) ---- */
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('.product-qty').querySelector('.qty-input');
      if (!input) return;
      var v = parseInt(input.value) || 1;
      if (btn.dataset.action === 'decrease' && v > 1) input.value = v - 1;
      if (btn.dataset.action === 'increase') input.value = v + 1;
    });
  });

  /* ---- Newsletter Form ---- */
  var nlForm = document.querySelector('.newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn   = nlForm.querySelector('button');
      var input = nlForm.querySelector('input[type="email"]');
      if (btn && input && input.value) {
        btn.textContent = 'Thank You!';
        input.value = '';
        setTimeout(function () { btn.textContent = 'Subscribe'; }, 3000);
      }
    });
  }

  /* ============================================================
     CART DRAWER
     IDs in theme.liquid:
       #cd          — drawer panel
       #cd-overlay  — dark background overlay
       #cd-close    — close button
       #cd-body     — scrollable items area
       #cd-loading  — spinner
       #cd-footer   — subtotal + checkout
       #cd-count    — item count in drawer header
       #cd-subtotal — subtotal price
     Header bag icon uses attribute [data-cart-toggle]
     Header count badge uses class .cart-count
  ============================================================ */

  var cdDrawer  = $('cd');
  var cdOverlay = $('cd-overlay');
  var cdClose   = $('cd-close');
  var cdBody    = $('cd-body');
  var cdLoading = $('cd-loading');
  var cdFooter  = $('cd-footer');
  var cdCount   = $('cd-count');
  var cdSub     = $('cd-subtotal');

  /* Open */
  function openCart() {
    if (!cdDrawer) return;
    cdDrawer.classList.add('open');
    if (cdOverlay) cdOverlay.classList.add('open');
    lockScroll();
    renderCart();
  }

  /* Close */
  function closeCart() {
    if (!cdDrawer) return;
    cdDrawer.classList.remove('open');
    if (cdOverlay) cdOverlay.classList.remove('open');
    unlockScroll();
  }

  if (cdClose)   cdClose.addEventListener('click', closeCart);
  if (cdOverlay) cdOverlay.addEventListener('click', closeCart);

  /* Bag icon in header */
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', openCart);
  });

  /* Escape key closes whichever drawer is open */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    closeNav();
  });

  /* Safety net — if tab regains focus with nothing open, release lock */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) unlockScroll();
  });

  /* ---- Render cart contents ---- */
  function renderCart() {
    if (cdLoading) cdLoading.style.display = 'flex';
    if (cdFooter)  cdFooter.style.display  = 'none';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cdLoading) cdLoading.style.display = 'none';
        updateCountBadges(cart.item_count);
        if (cdCount) cdCount.textContent = cart.item_count;
        if (cart.item_count === 0) {
          renderEmpty();
        } else {
          renderItems(cart);
          if (cdSub)    cdSub.textContent = money(cart.total_price);
          if (cdFooter) cdFooter.style.display = 'block';
        }
      })
      .catch(function () {
        if (cdLoading) cdLoading.style.display = 'none';
        renderEmpty();
      });
  }

  /* ---- Empty bag state ---- */
  function renderEmpty() {
    if (!cdBody) return;
    cdBody.innerHTML =
      '<div class="cd__empty">' +
        '<div class="cd__empty-icon">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
            '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/>' +
            '<path d="M16 10a4 4 0 0 1-8 0"/>' +
          '</svg>' +
        '</div>' +
        '<h4>Your bag is empty</h4>' +
        '<p>Discover our luxury skincare collection.</p>' +
        '<a href="/collections/all" class="cd__shop-btn">Shop Now</a>' +
      '</div>';
    if (cdFooter) cdFooter.style.display = 'none';
    if (cdCount)  cdCount.textContent = '0';
  }

  /* ---- Render items list ---- */
  function renderItems(cart) {
    if (!cdBody) return;
    var html = '<div class="cd__items">';

    cart.items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + escHtml(item.product_title) + '" loading="lazy">'
        : '';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cd__item-variant">' + escHtml(item.variant_title) + '</span>'
        : '';

      html +=
        '<div class="cd__item" data-key="' + item.key + '">' +
          '<div class="cd__item-img">' +
            '<a href="' + item.url + '">' + imgHtml + '</a>' +
          '</div>' +
          '<div class="cd__item-info">' +
            '<span class="cd__item-vendor">' + escHtml(item.vendor) + '</span>' +
            '<a class="cd__item-name" href="' + item.url + '">' + escHtml(item.product_title) + '</a>' +
            variantHtml +
            '<div class="cd__item-row">' +
              '<span class="cd__item-price">' + money(item.final_line_price) + '</span>' +
              '<div class="cd__qty">' +
                '<button class="cd__qty-btn" data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">&#8722;</button>' +
                '<span class="cd__qty-val">' + item.quantity + '</span>' +
                '<button class="cd__qty-btn" data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">&#43;</button>' +
              '</div>' +
            '</div>' +
            '<button class="cd__item-remove" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>';
    });

    html += '</div>';
    cdBody.innerHTML = html;

    /* Qty buttons */
    cdBody.querySelectorAll('.cd__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key    = btn.dataset.key;
        var qty    = parseInt(btn.dataset.qty) || 1;
        var newQty = btn.dataset.action === 'dec' ? qty - 1 : qty + 1;
        changeCartItem(key, Math.max(0, newQty));
      });
    });

    /* Remove buttons */
    cdBody.querySelectorAll('.cd__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartItem(btn.dataset.key, 0);
      });
    });
  }

  /* ---- Change line item quantity (0 = remove) ---- */
  function changeCartItem(key, qty) {
    if (cdLoading) cdLoading.style.display = 'flex';
    if (cdBody) {
      var items = cdBody.querySelector('.cd__items');
      if (items) items.style.opacity = '.4';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cdLoading) cdLoading.style.display = 'none';
      updateCountBadges(cart.item_count);
      if (cdCount) cdCount.textContent = cart.item_count;
      if (cart.item_count === 0) {
        renderEmpty();
      } else {
        renderItems(cart);
        if (cdSub)    cdSub.textContent = money(cart.total_price);
        if (cdFooter) cdFooter.style.display = 'block';
      }
    })
    .catch(function () {
      if (cdLoading) cdLoading.style.display = 'none';
      renderCart();
    });
  }

  /* ---- Add to cart ---- */
  function addToCart(variantId, qty, btn) {
    qty = qty || 1;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (btn) {
        btn.textContent = 'Added!';
        setTimeout(function () {
          btn.disabled  = false;
          btn.textContent = 'Add to Bag';
        }, 2000);
      }
      openCart();
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Bag'; }
    });
  }

  /* ---- Wire up product page Add to Bag button ---- */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var idInput  = document.querySelector('[name="id"]');
      var qtyInput = document.querySelector('.qty-input');
      var variantId = idInput ? idInput.value : null;
      var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
      if (variantId) addToCart(variantId, qty, btn);
    });
  });

  /* ---- Update header count badges ---- */
  function updateCountBadges(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* Load count on page load without opening drawer */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCountBadges(cart.item_count); })
    .catch(function () {});

  /* ---- Global helpers for Liquid snippets ---- */
  window.quickAdd  = function (variantId) { addToCart(variantId, 1, null); };
  window.openCart  = openCart;
  window.closeCart = closeCart;

  /* ---- HTML escape ---- */
  function escHtml(str) {
    return String(str || '')
      .replace(/&/g,  '&amp;')
      .replace(/</g,  '&lt;')
      .replace(/>/g,  '&gt;')
      .replace(/"/g,  '&quot;');
  }

  /* ---- Smooth scroll for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

})();

/* ============================================================
   VARIANT SELECTION
============================================================ */
(function () {
  var dataTag = document.querySelector('script[data-product-json]');
  if (!dataTag) return;

  var product;
  try { product = JSON.parse(dataTag.textContent); }
  catch (e) { return; }

  var variants = product.variants;
  if (!variants || !variants.length) return;

  var selected = {};

  /* Initialise from active swatches on page load */
  document.querySelectorAll('.option-swatch.active').forEach(function (sw) {
    selected[sw.dataset.option] = sw.dataset.value;
  });

  /* Swatch click handler */
  document.querySelectorAll('.option-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.option-swatches');
      if (group) {
        group.querySelectorAll('.option-swatch').forEach(function (b) { b.classList.remove('active'); });
      }
      btn.classList.add('active');
      selected[btn.dataset.option] = btn.dataset.value;
      var match = findVariant();
      if (match) updatePage(match);
    });
  });

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, idx) {
        var pos = String(idx + 1);
        return !(pos in selected) || selected[pos] === val;
      });
    }) || null;
  }

  function updatePage(v) {
    /* Hidden ID input */
    var idInput = document.getElementById('variant-id');
    if (idInput) idInput.value = v.id;

    /* URL */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch(e) {}

    /* Price */
    var priceEl = document.getElementById('product-price');
    if (priceEl) priceEl.textContent = money(v.price);

    /* Compare-at price */
    var compareEl = document.querySelector('.product-price__compare');
    var badgeEl   = document.querySelector('.product-price__badge');
    if (v.compare_at_price && v.compare_at_price > v.price) {
      if (compareEl) { compareEl.textContent = money(v.compare_at_price); compareEl.style.display = ''; }
      if (badgeEl) {
        var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        badgeEl.textContent = 'Save ' + pct + '%';
        badgeEl.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (badgeEl)   badgeEl.style.display   = 'none';
    }

    /* Add to Bag button */
    var atcBtn = document.querySelector('[data-add-to-cart]');
    if (atcBtn) {
      atcBtn.disabled    = !v.available;
      atcBtn.textContent = v.available ? 'Add to Bag' : 'Sold Out';
    }

    /* Buy It Now */
    var binBtn = document.querySelector('a[href*="/checkout?variant="]');
    if (binBtn) binBtn.href = '/checkout?variant=' + v.id + '&quantity=1';

    /* Sticky ATC */
    var satcBtn   = document.querySelector('.satc__btn');
    var satcPrice = document.querySelector('.satc__price');
    if (satcBtn) {
      satcBtn.dataset.variantId = v.id;
      satcBtn.disabled = !v.available;
      satcBtn.textContent = v.available ? 'Add to Bag' : 'Sold Out';
    }
    if (satcPrice) satcPrice.textContent = money(v.price);

    /* Featured image */
    if (v.featured_image && v.featured_image.src) {
      var mainImg = document.getElementById('main-product-image');
      if (mainImg) mainImg.src = v.featured_image.src;
    }
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
})();

/* Expose openCart globally for sticky ATC */
if (typeof openCart === 'undefined') {
  window.openCart = function() {
    var cd = document.getElementById('cd');
    var ov = document.getElementById('cd-overlay');
    if (cd) cd.classList.add('open');
    if (ov) ov.classList.add('open');
    document.body.classList.add('scroll-lock');
  };
}

